module.exports = __webpack_public_path__ + "static/media/brazil-flag.991bd13f.png";